import { numberFormat as numberFormatUiKit } from "@xola/ui-kit";
import { getSeller } from "./getSeller";
import { normalizeLocale } from "./locale";

type NumberFormat = (
    amount: number,
    currency?: string | null,
    maximumFractionDigits?: number,
    isCompact?: boolean,
    isNarrowSymbolForm?: boolean,
) => string;

export const numberFormat: NumberFormat = (amount, currency, maximumFractionDigits, isCompact, isNarrowSymbolForm) => {
    const { locale: sellerLocale } = getSeller();
    const locale = normalizeLocale(sellerLocale);

    return numberFormatUiKit(amount, currency, locale, maximumFractionDigits, isCompact, isNarrowSymbolForm);
};
